import CloudformationOutputs from '../CloudformationOutputs.json'

export function getOrgImageUrl(organisationImageCode: string | null, fileName: string) {
  const path = `/org-images/${organisationImageCode}/${fileName}`
  const stackName = (CloudformationOutputs as any).StackName

  if (!stackName || stackName === 'checqrtesting') return `https://test-dashboard.checqr.net${path}`
  if (stackName === 'production') return `https://dashboard.checqr.net${path}`

  return path
}
